<div class="header" [ngClass]="isAnpp ? 'theme-anpp' : 'theme-vin'">
  <div class="header-left">
    @if (isAnpp) {
      <img src="/assets/img/logo-anpp-grey.png" width="100px" height="50px" alt="Logo ANPP"/>
    } @else {
      <img src="/assets/img/logo-innov-violet.png" width="145px" alt="Logo Vin"/>
    }

    @if (pageTitleKey) {
      <span class="page-title">{{ pageTitleKey | translate }}</span>
    }

    @if (operateur) {
      <div class="d-flex align-items-center">
        <span>{{operateur.raisonSociale}}</span>
        <button type="button" (click)="changeOperateur()" class="btn btn-outline-primary ms-2">Changer</button>
      </div>
    }
  </div>

  <button pButton (click)="menu.toggle($event)">
    <i pButtonIcon class="pi pi-user pe-2"></i>
    <span pButtonLabel class="pe-3">{{ utilisateur?.prenom }} {{ utilisateur?.nom | uppercase }}</span>
    <i pButtonIcon class="pi pi-arrow-down ps-3"></i>
  </button>

  <p-menu #menu [popup]="true" [model]="items"></p-menu>
</div>
